/**
 =========================================================
 * Soft UI Dashboard PRO React - v3.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Soft UI Dashboard PRO React base styles
import colors from '../colors';

// Soft UI Dashboard PRO React helper functions
import rgba from '../../functions/rgba';
import { Z_INDEX_MOBILE_MENU } from '../../../components/Sidebar/constants';

const { primary, white, dark } = colors;

export default {
    '.flatpickr-day, span.flatpickr-weekday, .flatpickr-current-month, .flatpickr-input, .flatpickr-time input, .flatpickr-am-pm':
        {
            color: `${dark.main} !important`,
            transition: 'background .2s',
        },

    '.flatpickr-day:hover, .flatpickr-day:focus, .flatpickr-day.nextMonthDay:hover, .flatpickr-day.nextMonthDay:focus':
        {
            background: rgba(primary.main, 0.28),
            border: 'none',
        },

    '.flatpickr-day.today': {
        '&:hover, &:focus': {
            background: `${rgba(primary.main, 0.28)} !important`,
        },
    },

    '.flatpickr-day.selected, .flatpickr-day.selected:hover, .flatpickr-day.nextMonthDay.selected, .flatpickr-day.nextMonthDay.selected:hover, .flatpickr-day.nextMonthDay.selected:focus':
        {
            background: `${primary.main} !important`,
            color: `${white.main} !important`,
            border: 'none',
            fontWeight: 'bold',
        },

    '.flatpickr-months .flatpickr-next-month:hover svg, .flatpickr-months .flatpickr-prev-month:hover svg':
        {
            color: `${primary.main} !important`,
            fill: `${primary.main} !important`,
        },

    '.flatpickr-confirm': {
        padding: '4px !important',
        margin: '4px',
        cursor: 'pointer',
        background: `${primary.main} !important`,
        color: white.main,
        borderRadius: '6px',
        fontWeight: 'bold',
        fontSize: '12px',
    },
    '.flatpickr-calendar.open': {
        zIndex: `${Z_INDEX_MOBILE_MENU} !important`,
    },
    '.flatpickr-time .numInputWrapper span': {
        width: '32px',
        '&::after': {
            left: '50%',
            transform: 'translateX(-50%)',
        },
    },
};
